module.exports = __webpack_public_path__ + "images/5f519df5418d4f976c72b7240877d0b3174b22bddbb1d98f2db3e4d8f6a3ee01.svg";